module.exports = __webpack_public_path__ + "static/team-25-e9c13ed543ffadeac61cf864289711d1.jpg";